import { Link } from 'react-router';
import { ITab } from '../../types';
import './style.scss';

interface IProps {
  tab: ITab;
}

function Tab(props: IProps) {
  const selected = window.location.pathname.toLowerCase() === props.tab.href.toLowerCase();

  const classParts = ['tab-nHahus'];

  if (selected) {
    classParts.push('selected-N1as');
  }

  return (
    <Link
      className={classParts.join(' ')}
      to={props.tab.href}
    >
      <div className='tab-icon-u41A'>{props.tab.icon}</div>
      <div>{props.tab.title}</div>
    </Link>
  );
}

export default Tab;
